// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__qBdjT","button":"SearchBar_button__zjQ9i","input":"SearchBar_input__35An9"};